export const resetPassword = {
  form: {
    submit: "Submit",
  },
  title: "Reset your password",
};
